export const linkColorData = [
  {
    text: "Use the ",
    code: "data-bs-title, data-bs-trigger='click'",
  },
  {
    text: " to the content under the HTML tag with click event.",
  },
];

export const darkThemeList = [
  {
    title: "Secondary ",
    color: "secondary",
  },
  {
    title: "Tertiary ",
    color: "tertiary",
  },
  {
    title: " Success ",
    color: "success",
  },
  {
    title: " Info",
    color: "info",
  },
];

export const darkThemeLists = [
  {
    title: " Danger ",
    color: "danger",
  },
  {
    title: " Light ",
    color: "light",
    className: "dark",
  },
  {
    title: " Dark ",
    color: "dark",
  },
];

export const lightThemeList = ["Secondary","Tertiary", "Success", "Info"];

export const lightThemeLists = [
  {
    title: "Danger Alert",
    color: "light-danger",
  },
  {
    title: "Light Alert",
    color: "light-light",
  },
  {
    title: "Dark Alert",
    color: "light-dark",
  },
];

export const outLineLightData = [
  {
    text: "Use the ",
    code: ".border-*",
  },
  {
    text: "utility class to quickly provide matching border and border-width within any alert.",
  },
];

export const iconTextData = [
  {
    text: "Use the ",
    code: ".dismiss-text",
  },
  {
    text: " class to add dismiss text instead of icon",
  },
];

export const dismissingDarkData = [
  {
    text: "Use the ",
    code: ".alert-dismissible",
  },
  {
    text: " utility class to quickly remove the alerts.",
  },
];

export const dismissingLightData = [
  {
    text: "Use the ",
    code: ".alert-dismissible",
  },
  {
    text: " utility class to quickly remove the alerts.",
  },
];

export const liveAlertData = [
  {
    text: "Click the button below to show an alert,then dismiss it with the built-in close button.",
  },
];

export const leftData = [
  {
    text: "Use the ",
    code: ".b-l-*, b-t-* ",
  },
  {
    text: "for different color with direction border.",
  },
];

export const additionalData = [
  {
    text: "Use the ",
    code: ".alert , .bg-light-* ",
  },
  {
    text: " utility class to quickly provide additional content within any alerts.",
  },
];

export const additionalList = [
  {
    color: "secondary",
    title: "Something went wrong! Please, chrome update.",
    paragraph1:
      "The duty of notification is imposed upon the head of the family, and also upon the medical practitioner who may be in attendance on the patient.",
    paragraph2:
      "The emergency notification system is free and is available in all 50 states.",
  },
  {
    color: "tertiary",
    title: "Please! Hidden cameras were not installed.",
    paragraph1:
      "Due to increasingly accessible technology, hidden cameras have grown in popularity among regular people in recent years.",
    paragraph2:
      "Consider moving clocks and plush animals from your area if you think they may be concealing cameras because they are both portable items.",
  },
];
